if (typeof SwiperCarouselHero !== 'function') {
  class SwiperCarouselHero extends HTMLElement {
    constructor() {
      super()
      this.slideAmount = this.querySelectorAll('.swiper-slide').length
      this.swiperContainer = this.querySelector('.swiper')
      this.swiperParams = {
        loop: true,
        allowTouchMove: false,
        preventClicks: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        lazyPreloadPrevNext: 2,
        speed: 0.1,
        autoplay: {
          delay: 2200,
          disableOnInteraction: false
        }
      }

      if (this.dataset.breakpoints) {
        this.swiperParams['breakpoints'] = {
          480: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          }
        }
      }
      let delay = this.dataset.delay ? this.dataset.delay : 2200
      this.swiperParams['autoplay'] = {
        delay: delay,
        disableOnInteraction: false
      }
      this.swiperInstance = new Swiper(this.swiperContainer, this.swiperParams)
    }
  }
  if (!customElements.get('swiper-carousel-hero')) {
    customElements.define('swiper-carousel-hero', SwiperCarouselHero)
  }
}